import * as React from 'react';

import { EntityActions, EntityType } from 'common/entity';

import { MemberLink } from 'common/components/link/MemberLink';
import { AppState } from 'common/models/AppState';
import { Badge } from 'common/components/Badge';
import { Datetime } from 'common/components/Datetime';
import { InfiniteList } from 'common/components/InfiniteList';
import { Loading } from 'common/components/Loading';
import { Money } from 'common/components/Money';
import { Order } from 'common/api/models/Order';
import { OrderApi } from 'common/api/resources/OrderApi';
import { toApiError } from 'common/utils/api';

interface OrdersTableProps {
  appState: AppState;
  entityActions: EntityActions;
  reloadAt: Date;
  onClick: (orderNumber: number) => void;
}
interface OrdersTableState {
  orders: Order[];
  next?: number;
  isLoading: boolean;
  error?: string;
}
export class OrdersTable extends React.Component<OrdersTableProps, OrdersTableState> {
  state: OrdersTableState = { orders: [], isLoading: true };

  componentDidMount() {
    this.reload();
  }

  handleRowClick = (e: React.MouseEvent<HTMLTableRowElement>) => {
    e.stopPropagation();
    this.props.onClick(Number(e.currentTarget.dataset.number));
  };

  componentDidUpdate(prevProps: OrdersTableProps) {
    if (prevProps.reloadAt !== this.props.reloadAt) {
      this.reload();
    }
  }

  reload() {
    this.setState({ isLoading: true });

    OrderApi.getOrders({ from: this.state.next, limit: 20 }).then(
      res => {
        this.setState(s => ({
          orders: s.next ? [...s.orders, ...res.data] : res.data,
          isLoading: false,
          next: res.next,
        }));
        let memberIds: string[] = [];
        let productIds: string[] = [];
        for (let order of res.data) {
          memberIds.push(order.createId!);
          memberIds.push(order.accountId!);
          order.items!.map(item => {
            productIds.push(item.productId);
          });
        }
        this.props.entityActions.fetchMissingIds(EntityType.MEMBER, memberIds);
        this.props.entityActions.fetchMissingIds(EntityType.PRODUCT, productIds);
      },
      err => {
        this.setState({ error: toApiError(err), isLoading: false });
      }
    );
  }

  handleLoadMore = () => {
    this.reload();
  };

  render() {
    const cols = 9;
    const products = this.props.appState.entities.product;
    const members = this.props.appState.entities.member;
    return (
      <div>
        {this.state.error && (
          <div className="alert alert-danger" style={{ marginTop: 20 }}>
            {this.state.error}
          </div>
        )}

        <InfiniteList hasMore={!!this.state.next} isLoading={this.state.isLoading} onLoadMore={this.handleLoadMore}>
          <table className="table table-striped table-hover table-clickable" style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>Num</th>
                <th>Account</th>
                <th>Items</th>
                <th>Billed</th>
                <th>Paid</th>
                <th>Status</th>
                <th>Payment</th>
                <th>Last Activity</th>
                <th>Placed</th>
                <th>Placed By</th>
              </tr>
            </thead>
            <tbody>
              {this.state.orders.length === 0 && !this.state.isLoading && (
                <tr>
                  <td colSpan={cols}>No results found.</td>
                </tr>
              )}
              {this.state.orders.map(o => (
                <tr key={o.id} data-number={o.number} onClick={this.handleRowClick}>
                  <td>{o.number}</td>
                  <td>
                    <MemberLink member={members[o.accountId!]} />
                  </td>
                  <td>
                    <small>
                      {o.items!.map(i => (
                        <div key={i.productId}>
                          x{i.qty} {products[i.productId!] ? products[i.productId!].name : ''}
                        </div>
                      ))}
                    </small>
                  </td>
                  <td>
                    <Money value={o.billAmount!} />
                  </td>
                  <td>
                    <Money value={o.paymentAmount!} />
                  </td>
                  <td>
                    {o.status === Order.Status.PAID && <Badge type="success" text="Paid" />}
                    {o.status === Order.Status.PENDING && <Badge type="warning" text="Pending" />}
                    {o.status === Order.Status.CANCELLED && <Badge type="danger" text="Cancelled" />}
                  </td>
                  <td>
                    {o.transactionType === Order.TransactionType.CHECK && <span>Check</span>}
                    {o.transactionType === Order.TransactionType.CHARGE && <span>Charge</span>}
                  </td>
                  <td>
                    <Datetime at={o.lastStatusUpdate} />
                  </td>
                  <td>
                    <Datetime at={o.createAt} />
                  </td>
                  <td>
                    <MemberLink member={members[o.createId!]} />
                  </td>
                </tr>
              ))}
              {this.state.isLoading && (
                <tr>
                  <td colSpan={cols}>
                    <Loading />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </InfiniteList>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Orders/OrdersTable.tsx